import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article9() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });



  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';

      return "";
    }
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article10');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article8');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap article9-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article9-left-img1.jpg")} />
        </motion.div>
        <div className="article-right article9-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article9-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-3">Wild Venison Carpaccio <br /><span className="f-lora-i">on Sourdough</span></h1>
              <h6 className="f-lora-i lh-base mb-4 mb-sm-5" variants={textAnimate}>Wild Venison is the most sustainable meat we can consume in the UK and is widely available here in Scotland. This recipe is perfect for brunch or lunchtime eating. </h6>
              
              <p className="f-lora fw-bold mb-3">Ingredients (serves 2) </p>
              <p className="mb-4 mb-sm-5">1 wild venison steak
              <br/>2 egg yolks
              <br/>½ clove garlic
              <br/>1 tsp of dijon mustard
              <br/>350 ml of Highland rapeseed oil
              <br/>½ tsp of grated horseradish
              <br/>½ tbsp of sunflower seeds
              <br/>2 radishes, finely sliced
              <br/>1 tbsp of pickled sauerkraut
              <br/>Finely sliced rhubarb (optional)
              <br/>Two nice slices of sourdough</p>

              <p className="f-lora fw-bold mb-3">Method </p>
              <p className="mb-2">Prepare a fire and let it burn down to a bed of glowing embers.</p>
              <p className="mb-2">Place an iron grill over the embers and refuel the fire to increase the heat. </p>
              <p className="mb-2">Brush the sourdough with garlic and put aside.  </p>
              <p className="mb-2">Place a large, cast iron pan over the fire. While the pan is heating up, brush the venison steak with olive oil and season with salt and pepper. When the cast iron is very hot, place the venison steak into the pan and sear for three minutes on each side - making sure that it is nicely brown
              all over. When cooked, put aside to cool down for at least 30 minutes. </p>
              <p className="mb-2">In a bowl, whisk the egg yolk, dijon mustard and garlic together briefly before gradually pouring in the rapeseed oil. When the aioli has emulsified, season with salt and pepper and add in the
              grated horseradish. </p>
              <p className="mb-2">Place a small cast iron pan over the fire and gently toast the sunflower seeds until nice and golden. Finely slice the radish and rhubarb and put aside.  </p>
              <p className="mb-2">Lay the slices of sourdough over the fire and toast gently on each side. Carefully slice the venison steak. </p>
              <p className="mb-4 mb-sm-5">To assemble, place a slice of sourdough on the plate, spoon over the aioli, before laying the slices of wild venison on top. Garnish with the remainder of the ingredients and season with salt and pepper</p>
            </div>
          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article9;
